import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  all(data = {}) {
    return BackendAPI('get', ApiRoutes.notification.all(), data);
  },
  get(id) {
    return BackendAPI('get', ApiRoutes.notification.get(id));
  },
  create(data) {
    return BackendAPI('post', ApiRoutes.notification.create(), data);
  },
  update(id, data) {
    return BackendAPI('put', ApiRoutes.notification.update(id), data);
  },
  delete(id) {
    return BackendAPI('delete', ApiRoutes.notification.delete(id));
  },
};
